import { signDocumentsSlice } from './slice'

const signDocumentsActions = {
	...signDocumentsSlice.actions,
}

export default signDocumentsActions
